import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch, FaList, FaThumbsUp } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import Alert from '../../../components/Alert';
import api from '../../../services/api';
import ReactSelect from '../../../components/ReactSelect';
import { toast } from 'react-toastify';
import '../../../css/financeiro-parcela-pagar.css';

export default function PainelEventoChecklistModelo({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({});
    const [buscando, setBuscando] = useState(false);
    const [eventoChecklists, setEventoChecklistModelos] = useState([]);

    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const toggleSelect = id => setSelectedIds(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
    const toggleAll = () => paginados.length > 0 && selectedIds.size === paginados.length ? setSelectedIds(new Set()) : setSelectedIds(new Set(paginados.map(r => r.id)));
    const total = eventoChecklists.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = eventoChecklists.slice((page - 1) * pageSize, page * pageSize);
    const selectedArr = [...selectedIds];

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/eventoChecklistModelo',
            token: token,
            params: {
                ...filtro,
            },
            signal: controllerRef.current.signal
        })
            .then(response => {
                setEventoChecklistModelos(response.data.data);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
            });
    };

    const excluir = (rowId) => {
        Alert({
            icon: "error",
            confirmButton: "Sair",
            denyButton: <><FaThumbsUp size={20} /> Excluir</>,
            title: "Excluir",
            callBack: (result) => {
                if (result.isDenied) {
                    api({
                        method: 'delete',
                        action: '/eventoChecklistModelo/' + rowId,
                        token: token
                    })
                        .then(function (response) {
                            setSelectedIds(new Set());
                            buscar();
                        })
                        .catch(function (error) {
                            //alert(error)
                        });
                }
            }
        });
    };

    useEffect(() => {
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    const getClienteLabel = (row) => {
        if (row.cliente) {
            if (row.cliente?.enderecomunicipio) {
                return row.cliente.codigo + ' - ' + row.cliente.nome + ' - ' + row.cliente.enderecomunicipio.nome + ' - ' + row.cliente.enderecomunicipio.uf;
            } else {
                return row.cliente.codigo + ' - ' + row.cliente.nome;
            }
        }
        return "";
    };

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Modelos de Checklist</h1></div>
                    <div className="fin-pp__actions">
                        <Link to="/cadastroEventoChecklistModelo" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"><FaPlus size={14} /> Novo Modelo</Link>
                        {['admin', 'diretor', 'gerenteprojeto'].includes(perfil) ?
                            <Link to="/eventoChecklistAtividade" className="fin-pp__btn fin-pp__btn--pill" style={{ marginLeft: 8 }}><FaList size={14} /> Lista de Atividades</Link> :
                            null}
                    </div>
                </div>

                <form className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }} onSubmit={e => { buscar(); e.preventDefault(); }}>
                    <div className="fin-pp__filters">
                        <div className="fin-pp__field">
                            <label className="fin-pp__label">Cliente</label>
                            <ReactSelect
                                id="cliente"
                                value={{ value: filtro.cliente, label: filtro.nomeCliente }}
                                onChange={e => setFiltro({ ...filtro, ...{ "cliente": e.value, "nomeCliente": e.label } })}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/participante',
                                        token: token,
                                        params: {
                                            nome: input,
                                            tipoCadastro: "cliente",
                                            situacaoRegistro: "ativo",
                                        }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map((registro) => {
                                                var label = registro.codigo +
                                                    ' - ' + registro.nome +
                                                    (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                    (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                    (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                    (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                return {
                                                    value: registro.id,
                                                    label: label
                                                };
                                            });
                                            return options;
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                            <FaSearch size={14} /> {buscando ? 'Buscando...' : 'Buscar'}
                        </button>
                    </div>
                </form>

                {selectedArr.length === 1 && ['admin', 'diretor', 'gerenteprojeto', 'rsvp'].includes(perfil) && (
                    <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <button type="button" className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm" onClick={() => excluir(selectedArr[0])}>
                            <ImCancelCircle size={14} /> Excluir
                        </button>
                    </div>
                )}

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead><tr>
                                <th style={{ width: 40 }}><input type="checkbox" checked={paginados.length > 0 && selectedIds.size === paginados.length} onChange={toggleAll} /></th>
                                <th style={{ width: 60 }}></th>
                                <th style={{ width: 80 }}>Código</th>
                                <th>Nome</th>
                                <th>Tipo de Evento</th>
                                <th>Formato</th>
                                <th>Nacionalidade</th>
                                <th>Cliente</th>
                            </tr></thead>
                            <tbody>
                                {buscando ? <tr><td colSpan={8} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                    : paginados.length === 0 ? <tr><td colSpan={8} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td><input type="checkbox" checked={selectedIds.has(row.id)} onChange={() => toggleSelect(row.id)} /></td>
                                                <td>
                                                    {row.bancoDados !== undefined && (
                                                        <Link to={{ pathname: "/cadastroEventoChecklistModelo/" + row.id, state: { evento: id } }} className="fin-pp__rowbtn">
                                                            <FaPen size={14} />
                                                        </Link>
                                                    )}
                                                </td>
                                                <td style={{ textAlign: 'right' }}>{row.codigo ?? ""}</td>
                                                <td className="fin-pp__cell-strong">{row.nome ?? ""}</td>
                                                <td>{row.eventoTipo ?? ""}</td>
                                                <td>{row.eventoTipoRealizacao ?? ""}</td>
                                                <td>{row.eventoNacionalidade ?? ""}</td>
                                                <td>{getClienteLabel(row)}</td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select className="fin-pp__select" style={{ height: 34 }} value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                                <option value={15}>15 / pág</option><option value={30}>30 / pág</option><option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
